export default __webpack_public_path__ + "static/media/pancakeswapon.883523fd.png";